<template>
  <div>
    <loading :active="isLoading" :can-cancel="true" color="#173EA3" :is-full-page=fullPage></loading>
    <div style="text-align: right">
      <Button
        icon="pi pi-print"
        @click="printQr()"
        class="p-button-rounded p-button-info mr-2 mb-2"
      />
    </div>
    <div id="printMe">
      <div
        v-for="(result, key) in Printdata"
        :key="key"
      >
        <table :id="'DCprint_' + result.data.sr_no"
          style="
            border: 1px solid black;
            border-collapse: collapse;
            width: 753px;height:1083px;
            font-size: 0.875rem;
            margin-left: 30px;
            margin-top: 20px;margin-bottom:20px;
            font-family: Arial, Helvetica, sans-serif;
          "
        >
          <tr>
            <td
              colspan="6"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                padding-bottom: 0;
                font-size: large;
                font-weight: 900;
              "
            >
              DELIVERY CHALLAN
            </td>
          </tr>
          <tr>
            <td
              colspan="6"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              &nbsp;
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              <b>Sarvasya Merchandisers Private Limited</b><br />
              16-C,2nd Flr,16,The International Building,<br />
              1st X Road, New Marine Lines, Churchgate,<br />
              Mumbai - 400020
            </td>
            <td
              colspan="4"
              style="
                text-align: left;
                vertical-align: top;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              <b style="margin-right: 15px">Challan No:</b>SMPL/PACS/{{
                result.data["sr_no"]
              }}/23-24<br />
              <b>Challan Date:</b> {{getCurrentDate()}}
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 45%;
              "
            >
              <b>GST No. : 27AAYCS5283N2Z5<br />PAN : AAYCS5283N</b>
            </td>
            <td
              colspan="4"
              style="
                text-align: left;
                vertical-align: top;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              <b>P.O No. : </b
              ><small
                >Agri Credit-12/PAC Comp/Hardware/Sarvasya/ 2023/1767</small
              >
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 45%;
              "
            >
              Phone : 022-41012220/41012221
            </td>
            <td
              colspan="4"
              style="
                text-align: left;
                vertical-align: top;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              <b>P.O Date. : </b>21.11.2023
            </td>
          </tr>
          <tr style="height: 5px">
            <td
              colspan="6"
              style="
                text-align: left;
                height: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              &nbsp;
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              valign="top"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Consignee (Ship To)</b><br />
              {{split_name(result.data.group_stops.stop_name)}} <br>
               At-post {{result.data.group_stops.village_name}} , taluka-{{result.data.block_name}} , District-{{result.data.district_name}}
            </td>
            <td
              colspan="4"
              valign="top"
              style="
                text-align: left;
                height: 30px;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              <b
                >Goods Insured by Iffco-Tokio General Insurance Co.<br />
                Ltd. Vide Policy No.22G84744 dated: 30.11.2023
              </b>
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Pincode:</b> {{ result.data.group_stops.pin_code }}
            </td>

            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              Destination
            </td>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
            {{result.data.group_stops.village_name}},taluka-{{result.data.block_name}},District-{{result.data.district_name}}
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Secretory Name</b> {{ result.data.group_stops.secretory_name }}
            </td>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              Dispatched From
            </td>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              {{ result.data.group_stops.dispatch_from }}
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Mobile No.</b> {{ result.data.group_stops.mobile_no }}
            </td>

            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              Mode of Transport
            </td>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              {{ result.data.group_stops.mode_of_transport }}
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Unique PACS ID</b>{{ result.data.group_stops.PACS_id }}
            </td>

            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              Name of Transport
            </td>
            <td
              colspan="2"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
              "
            >
              {{ result.data.group_stops.transport_name }}
            </td>
          </tr>

          <tr>
            <td
              colspan="6"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                padding-left: 10px;
                width: 40%;
              "
            >
              <b>Buyer (Bill To)</b><br />
              Office of the Commissioner for Cooperation and 
              Registrar of Cooperative Societies, 
              New Central Building, B.J. Road, Pune - 411001 <br />
            </td>
          </tr>

          <tr style="background-color: rgb(247, 183, 66)">
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              SR No.
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
              "
            >
              <b>Description & Specification Of Goods</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              No of Goods
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              Total Qty. of Goods (Nett)
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              Price Per Unit Inclusive of Taxes
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              Total Price Of Goods
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              <b>Desktop(Monitor,CPU,Wired Keyboad & Mouse)s</b><br />
              Dell - Model : Vostro 3710 <br />
              HP - Model : Pro 285 G8 MT
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              2
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>65,700</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>65,700</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              2
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              Webcam<br />
              Model : TVSE W103
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>2,100</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>2,100</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              3
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              Multifunction Device MFD (Printer)<br />
              Model: Epson & M2170
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>24,230</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                padding-right: 5px;
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>24,230</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              4
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              Physical VPN Device<br />
              Model : D Link DIR 825 <br />
              Systrome IG-114C
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>10,357</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                padding-right: 5px;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>10,357</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              5
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              Biometric Scanner <br />
              Model : Mantra and MFS110
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                padding-right: 5px;
              "
            >
              <b>5,418</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                padding-right: 5px;
              "
            >
              <b>5,418</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              6
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              <b>Power Backup & Extension Socket Board</b> <br />
              UPS Model : Microtk Luxe 1400 <br />
              Battery : 150 AH
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              3
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              -<br />1<br />1
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                padding-right: 5px;
              "
            >
              <b> <br />4,200<br />9,800</b>
            </td>

            <td
              colspan="1"
              valign="top"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                padding-right: 5px;
              "
            >
              <b> <br />4,200<br />9,800</b>
            </td>
          </tr>
<!-- 
          <tr>
            <td
              colspan="1"
              valign="top"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              7
            </td>

            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
                padding-left: 10px;
              "
            >
              Extension Board & Socket
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              1
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              1
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>-</b>
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b>-</b>
            </td>
          </tr> -->

          <tr>
            <td
              colspan="1"
              style="
                text-align: left;
                border: 1px solid black;
                border-collapse: collapse;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                width: 40%;
              "
            >
              <b>TOTAL</b>
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
                width: 10%;
              "
            >
              9
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              7
            </td>

            <td
              colspan="1"
              style="
                text-align: center;
                border: 1px solid black;
                border-collapse: collapse;
              "
            >
              <b></b>
            </td>

            <td
              colspan="1"
              style="
                text-align: right;
                border: 1px solid black;
                border-collapse: collapse;
                padding-right: 5px;
              "
            >
              <b>1,21,805</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="1"
              style="
                text-align: left;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: left;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: left;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: left;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: left;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>

            <td
              colspan="1"
              style="
                text-align: left;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            ></td>
          </tr>

          <tr>
            <td
              colspan="6"
              style="
                text-align: left;
                padding-left: 10px;
                border-bottom: 1px solid black;
                border-collapse: collapse;
                height: 20px;
              "
            >
              <b>Received above mentioned materials in good condition.</b>
            </td>
          </tr>

          <tr>
            <td
              colspan="3"
              style="border-collapse: collapse; padding: 10px; height: 100px"
            >
            <p><b>Received By (Put Stamp)</b></p>
              <!-- <img src="file:///E:/download/QrIMAGE%20(2).PNG" alt="QR Code" height="100px" width="100" style="float: right;"> -->
              <qrcode-vue
                id="qrprint"
                type="image/png"
                style="width: 100; height: 100; float: right"
                :value="result.data.group_stops.uicode"
               
                
              />
              <p style="margin-top: 70px">
                <b>Sign :</b><br><br>
                <b>Name :</b><br><br>
                <b>Mobile :</b></p>
            </td>

            <td
              colspan="3"
              valign="top"
              style="
                text-align: left;
                border-left: 1px solid black;
                padding: 10px;
                border-collapse: collapse;
                height: 100px;
              "
            >
              <b>Sarvasya Merchandisers Private Limited</b>
              <p style="margin-top: 80px"><b>AUTHORISED SIGNATORY</b></p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import ProductService from "../../service/ProductService";
import { FilterMatchMode } from "primevue/api";
import apis from "@/apis";
import { jsPDF } from "jspdf";

import QrcodeVue from "qrcode.vue";
export default {
  props: ["Printdata"],
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    split_name(data)
    {
      var info=data.split("-");
      if (info.length>1) 
      {
        info.pop();
      }
      return info.toString();
    },
    async print_Qr() 
    {
      const pdf = new jsPDF();

            for (let i = 0; i < this.Printdata.length; i++) 
            {
              console.log('DCprint_' + this.Printdata[i].data.sr_no);
              const canvas = document.getElementById('DCprint_' + this.Printdata[i].data.sr_no);

              
              pdf.html(canvas);
              if (i < this.Printdata.length - 1) 
              {
                pdf.addPage();
              }
            }
          pdf.save("DC.pdf");

    },
    printQr() {
      this.isLoading=true;
      const pdfWidth = 800;
      const pdfHeight = 1103.55;
      const pdfContent = document.getElementById("printMe");
      const pdf = new jsPDF({
        unit: "mm",
        format: [pdfWidth, pdfHeight], // A4 size by default, you can customize this
        orientation: "portrait", // 'portrait' or 'landscape'
        autoPaging: 'text'
      });
      //const pdf = new jsPDF('portrait', 'pt', 'a4');
      
      pdf.html(pdfContent, {
        callback: (pdf)=> {
          // Save or display the generated PDF
          pdf.save("Delivery_Challan.pdf");
          this.isLoading=false;
          this.$emit("submit");          
        },
      });
      
    },
    getCurrentDate()
  {
    var fullDate = new Date();
    var twoDigitMonth = fullDate.getMonth() + 1;
    return  fullDate.getDate() + "/" + twoDigitMonth + "/" + fullDate.getFullYear();
  }
  },
  
  mounted() {
    console.log(this.Printdata);
  },
  components: { QrcodeVue },
};
</script>
<style>
.page-break {
  page-break-after: always !important;
}
</style>